import feathers from "@feathersjs/feathers";
import rest from "@feathersjs/rest-client";
import { batchClient } from "feathers-batch";
import feathersVuex from "feathers-vuex";
import authenticationClient from "@feathersjs/authentication-client";
import { iff, discard } from "feathers-hooks-common";
import getUrl from "../plugins/getUrl";

const restClient = rest(getUrl()).fetch(window.fetch);

const jwtStrategy = "jwt";

const transport = restClient;
const feathersClient = feathers()
  .configure(transport)
  .configure(batchClient({ batchService: "batch", exclude: ["authentication"] }))
  .configure(authenticationClient({ jwtStrategy, storage: window.localStorage }))
  .hooks({
    before: {
      all: [
        iff(
          (context) => ["create", "update", "patch"].includes(context.method),
          discard("__id", "__isTemp")
        ),
        async (ctx) => {
          const { app, path, method } = ctx;

          // skip if authentication / login request
          if (path === "authentication" && method === "create") {
            return ctx;
          }
          // skip if auth-management request
          if (path === "auth-management") {
            return ctx;
          }

          try {
            await app.reAuthenticate();
          } catch (error) {
            console.error("Could not re-authenticate", error);
          }

          try {
            if (!app?.authentication) {
              console.error("No authentication configured");
              return ctx;
            }

            // ensure params are set
            const token = await app.authentication.getAccessToken();

            ctx.params.accessToken = token;
            ctx.params.headers = { Authorization: `Bearer ${token}` };
          } catch (err) {
            console.error("Could not authenticate", err);
          }

          return ctx;
        },
      ],
    },
  });

const { BaseModel, makeServicePlugin, makeAuthPlugin, FeathersVuex } = feathersVuex(
  feathersClient,
  {
    serverAlias: "api",
  }
);

export { makeServicePlugin, makeAuthPlugin, BaseModel, FeathersVuex };
export default feathersClient;
